import { render, staticRenderFns } from "./ConfigMenu.vue?vue&type=template&id=39e20471"
import script from "./ConfigMenu.vue?vue&type=script&lang=js"
export * from "./ConfigMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports